var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#EDF2F7",
    width: 34,
    height: 34,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 8c.295 0 .536.238.536.531v1.594h6.428V8.531c0-.293.241-.531.536-.531.295 0 .536.238.536.531v1.594h1.071c1.182 0 2.143.951 2.143 2.125v10.625C25 24.047 24.04 25 22.857 25H12.143A2.135 2.135 0 0 1 10 22.875V12.25c0-1.174.96-2.125 2.143-2.125h1.071V8.531c0-.293.241-.531.536-.531zm10.179 6.375H11.07v8.5c0 .588.48 1.063 1.072 1.063h10.714c.593 0 1.072-.475 1.072-1.063v-8.5zm-1.072-3.188H12.143c-.592 0-1.072.475-1.072 1.063v1.063H23.93V12.25c0-.588-.48-1.063-1.072-1.063z",
    fill: "#1A202C",
    fillRule: "nonzero",
    stroke: "#1A202C",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.80906239.svg";
export { ForwardRef as ReactComponent };